var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-card van-hairline--surround",
      on: { click: _vm.linkTo }
    },
    [
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("经销商:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.data.deptName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("活动:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.data.Name))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("时间:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(
            _vm._s(
              (_vm.data.U_RangeTime || "").replace(/-/g, "/").replace(",", "-")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("地点:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.data.U_CampPlace))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("预算:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.$numeral(_vm.data.totalAmount).format("0,0")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear item1" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("活动报告:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.data.rptCnt > 0 ? "已提交" : "未提交"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line flex" }, [
        _c("p", [_vm._v("活动后30天销售情况:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content" }, [
          _vm._v(_vm._s(_vm.data.monthSalesCnt > 0 ? "已提交" : "未提交"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-status" }, [
        _vm._v("\n    " + _vm._s(_vm.data.approvalStatusName) + "\n    "),
        _vm.data.U_ApprovalStatus == "W" && _vm.data.auditName
          ? _c("p", [_vm._v("(" + _vm._s(_vm.data.auditName) + ")")])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-471bfa62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471bfa62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/activeListCard.vue
// module id = null
// module chunks = 